import { Type } from 'class-transformer'
import { Route } from './Room/Route'

export class Room {

  public readonly roomId: string

  public readonly name: string

  public readonly door: string

  public readonly floor: string

  @Type(() => Route)
  public readonly route?: Route | null

  constructor(
    roomId: string,
    name: string,
    door: string,
    floor: string,
    route?: Route,
  ) {
    this.roomId = roomId
    this.name = name
    this.door = door
    this.floor = floor
    this.route = route
  }
}
